import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`:`}</p>
    <p>{`My interest in Gondwana dispersion can be traced back many years.  Notable events include the discovery of the Okavango dyke swarm (Reeves, 1978) and the new fit of Madagascar to Africa resulting from early exploration of the Anza graben (Reeves et al, 1987).  The advent of geographical information systems in the 1990s led to my first attempts to improve the fit of all the southern continents advocated by de Wit et al (1988) and interpret newly-released ocean floor data as a record of the paths by which the southern continents dispersed over geological time (Reeves & de Wit, 2000).`}</p>
    <p>{`Early work at ITC was supported by internal research funding that enabled the initial purchase of the 'Atlas' plate modelling software from Cambridge Paleomap Servcies Limited and the consequent ability to animate plate models easily.  In turn, this brought geodynamics to the attention of a wider audience as well as to aspiring students of earth science.  Early animations found a place on an ITC website that proved very popular. The popularity contiunued well beyond my retirement in 2004.  The beginning of 2025 sees the relaunch of the animation (in the familiar colours of the original) but with data outlines and a plate model that includes many of the advances in understanding from the past 20-plus years.`}</p>
    <p>{`The 2025 version of the animation may be found `}<a parentName="p" {...{
        "href": "https://kartoweb.itc.nl/gondwana/"
      }}>{`here`}</a>{`.`}</p>
    <p>{`An up-to-date overview of the basic concepts as well as the history of the work is included `}<a parentName="p" {...{
        "href": "https://kartoweb.itc.nl/gondwana/researchproject.html"
      }}>{`in the website`}</a>{`.`}</p>
    <p>{`My thanks go to Barend Köbben who has implemented and published these animations from the outset. `}</p>
    <p><strong parentName="p">{`Colin Reeves`}</strong></p>
    <p><em parentName="p">{`2025 February 5`}</em></p>
    <p><em parentName="p">{`References`}</em></p>
    <p>{`De Wit, M.J. et al, 1988. Geological map of sectors of Gondwana reconstructed to their positions c150 Ma. Scale 1:10 000 000. AAPG.`}</p>
    <p>{`Reeves, C.V., 1978. A failed Gondwana spreading axis in southern Africa.  Nature, vol 273, pp 222-3.`}</p>
    <p>{`Reeves, C.V., Karanja, F.M. & MacLeod, I.N., 1987. Geophysical evidence for a failed Jurassic rift and triple junction in Kenya.  Earth & Planetary Science Letters, vol 81, pp 299-311.`}</p>
    <p>{`Reeves, C.V., & de Wit, M.J., 2000. Making Ends meet in Gondwana. Terra Nova vol 12, pp 272-280.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      